import {Injectable} from '@angular/core';
import {Observable} from "rxjs/Rx";
import {AngularFireDatabase} from '@angular/fire/database';
import {AngularFireAuth} from '@angular/fire/auth';

import {Router} from "@angular/router";
import {User} from "../model/user";
import {UserService} from "../model/user.service";
import {Club} from "../model/club";
import {ClubsService} from "../model/clubs.service";
import {sleepMilliseconds} from "../util/sleep-util";
import * as firebase from "firebase";
import {environment} from "../../../environments/environment";
import {TranslateService} from "@ngx-translate/core";
import {LastusedService} from "../model/lastused.service";

@Injectable()
export class AuthService {
  private currentUser: User = new User("", "", "", "", "", "", "", null, "" );
  private currentClub: Club = null;
  private isLoggedIn: boolean = false;
  private isSuccess: boolean = false;
  private lastUsed: string;
  user: Observable<firebase.User>;

  constructor(public afAuth: AngularFireAuth, private afDb: AngularFireDatabase, private router: Router, private userService: UserService, private clubService: ClubsService, private translate: TranslateService, private lastusedService: LastusedService) {
    //console.log('constructor AuthService');
    this.user = afAuth.authState;
    this.isSuccess = false;
  }

  login(email, password) {
    var retVal = false;

    this.currentUser.email = email;
    this.currentUser.role = "none";
    this.afAuth.auth.signInWithEmailAndPassword(email, password)
      .then(function(p) {
        //console.log("Logged in correctly!");
      })
      .catch(function(error) {
          // Handle Errors here.
        var errorCode = error.name;
        var errorMessage = error.message;

        //console.log(errorMessage);
      });

    sleepMilliseconds(1000);
    if(this.afAuth.auth.currentUser != null ) {
      this.isLoggedIn = true;
      this.addUserDetails();
      retVal = true;
    }

    return retVal;
  }

  signUp(email, password, clubId, name, phone, role, intensity, userService) {
    this.afAuth.auth.createUserWithEmailAndPassword(email, password)
      .then(function(result) {
        //console.log(result);
        //console.log("createUserWithEmailAndPassword response: " + result.user.uid);
        let uid = result.user.uid;
        userService.addUserToClub(uid, clubId, name, email, phone, role, intensity);
      })
      .catch(function(error) {
        // Handle Errors here.
        var errorCode = error.name;
        var errorMessage = error.message;
        if (errorCode === 'auth/weak-password') {
          alert('Password is not strong enough. Please use a better password.');
        } else {
          alert(errorMessage);
        }
        //console.log(error);
    });
  }

  resetPassword(email: string) {
    //console.log("Sending password reset email to: " + email);
    this.afAuth.auth.sendPasswordResetEmail(email);
  }


  isStillLoggedIn(): boolean {
    return this.isLoggedIn;
  }

  updateLastLoggedIn () {
    this.userService.setLastLoggedIn(this.currentUser.$key);
  }

  logout() {
    this.currentUser.refreshToken = "";
    this.afAuth.auth.signOut();
    this.isLoggedIn = false;
    //this.authInfo$.next(AuthService.UNKNOWN_USER);
    //this.router.navigate(['/home']);
  }

  getLastUsed(): string {
    if (this.lastUsed != null) {
      return this.lastUsed
    } else {
      return '--?--';
    }
  }

  getUserName(): string {
    if (this.currentUser != null) {
      return this.currentUser.name
    } else {
      return "";
    }
  }

  getUserId(): string {
    if ( this.currentUser !== null ) {
      return this.currentUser.userId;
    } else {
      return "";
    }
  }

  getCurrentUser(): User {
    return this.currentUser;
  }

  getDistributorCode(): number {
    if ( this.currentUser.distributorCode ) {
      return this.currentUser.distributorCode;
    } else {
      return 0;
    }
  }

  addUserDetails() {
    let uid = this.afAuth.auth.currentUser.uid;

    //console.log("uid: " + uid);
    // Next line was used to view idToken that can be used in REST calls as authentication header
    //console.log("ID token: " + this.afAuth.idToken.subscribe(x => console.log(x)));

    this.userService.findUserByUid(uid).subscribe(snapshot => {
      if (!snapshot.name) {
        //console.log(snapshot);
        alert("User has no role assigned. No login possible.");
        this.logout();
      } else {
        //console.log(this.afAuth.auth.currentUser.refreshToken);

        this.currentUser = snapshot;
        if ( this.afAuth.auth.currentUser !== null ) {
          this.currentUser.refreshToken = this.afAuth.auth.currentUser.refreshToken;
          //console.log(uid);
          //console.log(this.currentUser.refreshToken);
          this.currentUser.userId = uid;
          this.lastusedService.initLastUsedService(uid);
          this.lastusedService.getLastUsed().subscribe( l => {
            //console.log( `last used: ${l}` );
            const lu = Number(l);

            const lang = this.translate.currentLang;

            let locale = 'nl-NL';
            if ( lang === 'en' ) {
              locale = 'en-GB';
            } else if ( lang === 'de' ) {
              locale = 'de-DE';
            } else if ( lang === 'fr' ) {
              locale = 'fr-BE';
            }

            if ( lu > 1 ) {
              const n = new Date( lu );
              this.lastUsed = n.toLocaleString( locale );
            } else {
              this.lastUsed = '--?--';
            }
          });
        }
        //console.log("Current user:");
        //console.log(this.currentUser);
        this.clubService.findClubById(this.currentUser.club).subscribe(club => {
          this.currentClub = club;
          //console.log(this.currentClub.name);
        });
      }
    })
  }

  setClubDetails(clubId: string) {
    if ((this.currentUser.role === "ultrasuperuser" || this.currentUser.role === "superuser" || this.currentUser.role === 'distributor') && this.isLoggedIn) {
      this.clubService.findClubById(clubId).subscribe(club => {
        this.currentClub = club;
        //console.log(this.currentClub.name);
      });
    }
  }

  getUserLastLoggedIn(): string {
    if (this.currentUser != null && this.isLoggedIn) {
      const lli = Number( this.currentUser.lastLoggedIn );
      const lang = this.translate.currentLang;

      let locale = 'nl-NL';
      if ( lang === 'en' ) {
        locale = 'en-GB';
      } else if ( lang === 'de' ) {
        locale = 'de-DE';
      } else if ( lang === 'fr' ) {
        locale = 'fr-BE';
      }

      if ( lli > 1 ) {
        const n = new Date( lli );
        return n.toLocaleString( locale );
      } else {
        return this.currentUser.lastLoggedIn;
      }

    } else {
      return "";
    }
  }

  getUserRole(): string {
    if (this.currentUser != null && this.isLoggedIn) {
      return this.currentUser.role;
    } else {
      return "";
    }
  }

  getClubForUser(): string {
    if (this.currentClub != null && this.isLoggedIn) {
      return this.currentClub.name;
    } else {
      return "";
    }
  }

  getIntensityUser(): number {
    if (this.currentUser.intensity != null && this.isLoggedIn) {
      return this.currentUser.intensity;
    } else {
      return 100;
    }
  }

  getTenantIdForUser(): number {
    if (this.currentClub != null && this.isLoggedIn) {
      return this.currentClub.tenantId;
    } else {
      return 0;
    }
  }

  getClubIdForUser(): string {
    if (this.currentClub != null && this.isLoggedIn) {
      //console.log("Ik ben in getClubIdForUser(): " + this.currentClub.$key);
      return this.currentClub.$key;
    } else {
      return "";
    }
  }

  getClubNameForUser(): string {
    if (this.currentClub != null && this.isLoggedIn) {
      return this.currentClub.name;
    } else {
      return "";
    }
  }

  getRefreshToken(): string {
    if (this.currentClub !== null && this.isLoggedIn) {
      return this.currentUser.refreshToken;
    } else {
      return "";
    }
  }

  isSuperUser(): boolean {
    if (this.currentUser !== null) {
      if ((this.currentUser.role === "ultrasuperuser" || this.currentUser.role === "superuser") && this.isLoggedIn) {
        return true;
      } else {
        return false;
      }
    }
  }

  isUltraSuperUser() : boolean {
    if (this.currentUser !== null) {
      if (this.currentUser.role === "ultrasuperuser" && this.isLoggedIn) {
        return true;
      } else {
        return false;
      }
    }
  }

  isSuperAdminUser(): boolean {
    if (this.currentUser !== null) {
      if ((this.isSuperUser() || this.currentUser.role === "distributor" || this.currentUser.role === "superadmin") && this.isLoggedIn) {
        return true;
      } else {
        return false;
      }
    }
  }

  isPlayer(): boolean {
    if (this.currentUser !== null) {
      if ((this.currentUser.role === "player") && this.isLoggedIn) {
        return true;
      } else {
        return false;
      }
    }
  }

  isAdminUser(): boolean {
    if (this.currentUser !== null) {
      if ((this.isSuperUser() || this.currentUser.role === "distributor" || this.currentUser.role === "superadmin" || this.currentUser.role === "admin") && this.isLoggedIn) {
        return true;
      } else {
        return false;
      }
    }
  }

  isDistributor(): boolean {
    if (this.currentUser !== null) {
      if ( (this.currentUser.role === "distributor" || this.currentUser.role === "superuser" || this.currentUser.role === "ultrasuperuser" ) && this.isLoggedIn) {
        return true;
      } else {
        return false;
      }
    }
  }

}

